import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./schedule-list.component.html?ngResource";
import _ from 'lodash';
import { Component, ElementRef, EventEmitter, Input, Optional, Output, ViewChildren, ChangeDetectorRef, } from '@angular/core';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ConfirmationService } from 'primeng/api';
import { SECOND } from 'Utils/time';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { CommonModule } from '@angular/common';
import { ScheduleManagerService } from '../../services/schedule-manager.service';
import { ScheduleComponent } from '../schedule/schedule.component';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ConfirmDestructiveDialogComponent } from '../../../../components/confirm-destructive-dialog/confirm-destructive-dialog.component';
let ScheduleListComponent = class ScheduleListComponent {
    scheduleManager;
    confirmationService;
    cdr;
    config;
    org;
    set selected(id) {
        id = id ?? null;
        if (this.#selected !== id) {
            if (id === 'new') {
                this.addNewSchedule();
            }
            else {
                this.selectSchedule(id);
            }
        }
    }
    get selected() {
        return this.#selected;
    }
    selectedChanged = new EventEmitter();
    scheduleRefs;
    schedules = [];
    newSchedule = null;
    pendingDelete = null;
    #selected = null;
    #destroy$ = new Subject();
    constructor(scheduleManager, confirmationService, cdr, config) {
        this.scheduleManager = scheduleManager;
        this.confirmationService = confirmationService;
        this.cdr = cdr;
        this.config = config;
        // Workaround for setting org from dialog config
        if (this.config?.data?.org) {
            this.org = this.config.data.org;
        }
    }
    ngOnChanges(changes) {
        if (changes.org && !changes.org.isFirstChange()) {
            this.loadSchedules();
            this.newSchedule = null;
        }
    }
    ngAfterViewInit() {
        if (this.org) {
            this.loadSchedules();
        }
    }
    ngOnDestroy() {
        this.#destroy$.next(null);
        this.#destroy$.complete();
    }
    loadSchedules() {
        this.scheduleManager
            .getSchedules(this.org)
            .pipe(takeUntil(this.#destroy$))
            .subscribe((schedules) => {
            this.scheduleRefs.changes
                .pipe(take(1))
                .pipe(takeUntil(this.#destroy$))
                .subscribe(() => {
                if (this.selected) {
                    this.scrollTo(this.selected);
                }
            });
            this.schedules = schedules;
            if (this.schedules.length === 1) {
                this.selectSchedule(this.schedules[0].id);
            }
            this.cdr.detectChanges();
        });
    }
    onToggled($event, action) {
        const selected = action === 'open';
        const { index } = $event;
        const { id } = index < this.schedules.length ? this.schedules[index] : { id: 'new' };
        this.selectSchedule(selected ? id : undefined);
    }
    selectSchedule(id = null) {
        this.#selected = id;
        this.selectedChanged.emit(id);
        if (id) {
            this.scrollTo(id);
        }
    }
    scrollTo(id) {
        const index = _.findIndex([...this.schedules, { id: 'new' }], { id });
        if (index > -1) {
            _.delay(() => {
                const { nativeElement: item } = this.scheduleRefs.toArray()[index];
                item?.scrollIntoView?.({ behavior: 'smooth', inline: 'nearest' });
            }, SECOND / 2);
        }
    }
    addNewSchedule() {
        this.newSchedule = this.scheduleManager.getNewScheduleForOrg(this.org);
        this.selectSchedule('new');
    }
    confirmDiscard($event) {
        $event.stopPropagation();
        this.confirmationService.confirm({
            target: $event.target,
            message: 'Are you sure that you want to discard the new schedule?',
            icon: 'fad fa-exclamation-triangle',
            defaultFocus: 'reject',
            acceptLabel: 'Discard',
            acceptButtonStyleClass: 'p-button-warning',
            rejectButtonStyleClass: 'p-button-secondary',
            accept: () => {
                this.newSchedule = null;
                this.selectSchedule();
            },
            rejectVisible: false,
        });
    }
    newScheduleCreated(msg) {
        this.selectSchedule(msg.id);
        this.newSchedule = null;
    }
    confirmDelete($event, sched) {
        $event.stopPropagation();
        this.pendingDelete = {
            sched,
            title: 'Are you sure that you want to delete this schedule?',
            message: '',
        };
        this.scheduleManager.getAssociatedModels(sched.id)
            .pipe(takeUntil(this.#destroy$))
            .subscribe(({ associatedModels: associated }) => {
            let associatedStr = '';
            _.map({ gateUserLists: 'User Access Lists (doors/gates)', equipment: 'Equipment' }, (title, key) => {
                if (!_.isEmpty(_.get(associated, key))) {
                    if (associatedStr === '') {
                        associatedStr += 'This schedule has associated entities: \n';
                    }
                    associatedStr += `\t${title}:\n`;
                    associatedStr += _.reduce(associated[key], (acc, entity) => `${acc}\t\t• ${entity.name}\n`, '');
                }
            });
            this.pendingDelete.message += `${associatedStr}\n`;
        });
    }
    deleteSchedule(id) {
        this.scheduleManager
            .deleteSchedule(id)
            .pipe(takeUntil(this.#destroy$))
            .subscribe(() => {
            this.selectSchedule();
            this.cdr.detectChanges();
        });
    }
    static ctorParameters = () => [
        { type: ScheduleManagerService },
        { type: ConfirmationService },
        { type: ChangeDetectorRef },
        { type: DynamicDialogConfig, decorators: [{ type: Optional }] }
    ];
    static propDecorators = {
        org: [{ type: Input }],
        selected: [{ type: Input }],
        selectedChanged: [{ type: Output }],
        scheduleRefs: [{ type: ViewChildren, args: ['schedRef', { read: ElementRef },] }]
    };
};
ScheduleListComponent = __decorate([
    Component({
        selector: 'schedule-list',
        template: __NG_CLI_RESOURCE__0,
        providers: [ConfirmationService],
        standalone: true,
        imports: [
            CommonModule,
            AccordionModule,
            ButtonModule,
            ConfirmPopupModule,
            ScheduleComponent,
            ConfirmDestructiveDialogComponent
        ],
    })
], ScheduleListComponent);
export { ScheduleListComponent };
